import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { WtStorageService } from '../wt-storage.service';

@Injectable()
export class CachingService {

  private helper: JwtHelperService;



  constructor(private wtStorage: WtStorageService) {
    this.helper = new JwtHelperService();
  }


  private removeSelectedFixedZoneId() {
    this.wtStorage.removeItem('selectedLiveZoneId');
  }

  public JWTDecode(jsonWebToken: string): string {
    return this.helper.decodeToken(jsonWebToken).tObject;
  }


}

export function setCookie(name: string, val: string) {
  const date = new Date();
  const value = val;

  // Set it expire in 7 days
  date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000);

  // Set it
  document.cookie = name + '=' + value + '; expires=' + date.toUTCString() + '; path=/';
}

export function getCookie(name: string) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');

  if (parts.length == 2) {
    return parts.pop().split(';').shift();
  }

  return null;
}

export function deleteCookie(name: string) {
  const date = new Date();

  // Set it expire in -1 days
  date.setTime(date.getTime() + -1 * 24 * 60 * 60 * 1000);

  // Set it
  document.cookie = name + '=; expires=' + date.toUTCString() + '; path=/';
}
